import HomeIcon from '@mui/icons-material/Home'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SettingsIcon from '@mui/icons-material/Settings'
import { THEME } from '../../global'

export function BottomMenuNavigation() {
  return (
    <div className="fixed bottom-0 border-t border-tertiary  left-0 right-0 flex justify-between py-3 px-6">
      <div>
        <HomeIcon style={{ fontSize: '42px' }} color="primary" />
      </div>
      <div>
        <NotificationsIcon
          style={{ color: THEME.colors.tertiary, fontSize: '42px' }}
        />
      </div>
      <div>
        <SettingsIcon
          style={{ color: THEME.colors.tertiary, fontSize: '42px' }}
        />
      </div>
    </div>
  )
}
